import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SmoothLink, Sticky, Slugify, SanitizeHtml } from '@bd/bdcore-utilities';
import { colors } from '../../../styles';
import Carousel from '../../Carousel_Elliott';

const styles = css`
.PhotoGallery_categoryTitle {
  font-weight: 800;
  font-size: 24px;
  color: ${colors.body};
  letter-spacing: 4px;
  text-align: center;
  line-height: 36px;
  text-transform: uppercase;
  margin: 40px 0 80px 0;
  position: relative;
  @media (min-width: 992px) {
    font-size: 41px;
    margin: 0 0 80px 0;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 150px;
    height: 3px;
    left: 50%;
    margin-left: -75px;
    background-color: ${colors.neutral};
    bottom: -40px;
  }
}
.PhotoGallery_categoryPostTitle {
  font-weight: 300;
  color: ${colors.brand1};
}
.PhotoGallery_menu {
  padding: 0;
  text-align: left;
  width: 300px;
  display: none;
  position: absolute;
  left: 50%;
  margin-left: -150px;
  top: 40px;
  list-style: none;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
  &.open {
    display: block;
  }
  @media (min-width: 992px) {
    list-style: none;
    margin: 0;
    display: block;
    position: relative;
    width: auto;
    left: auto;
    margin-left: 0;
    top: auto;
    box-shadow: none;
    text-align: center;
    background-color: ${colors.brand1};
    margin: 0 0 90px 0;
  }
}
.PhotoGallery_menuItem {
  @media (min-width: 992px) {
    display: inline-block;
  }
  a {
    background-color: ${colors.white};
    padding: 10px 15px;
    border-bottom: 1px solid ${colors.neutral};
    display: block;
    color: ${colors.body};
    cursor: pointer;
    @media (min-width: 992px) {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      height: 80px;
      line-height: 1;
      color: ${colors.white};
      font-weight: 700;
      letter-spacing: 1px;
      text-align: center;
      padding: 0 15px;
      border: 0;
      font-size: 15px;
      opacity: .5;
      position: relative;
      &.active {
        color: ${colors.white};
        opacity: 1;
        &::after {
          content: '';
          display: block;
          position: absolute;
          bottom: 20px;
          left: 50%;
          height: 2px;
          width: calc(100% - 30px);
          transform: translateX(-50%);
          background-color: ${colors.brand2};
        }
      }
    }
  }
}
.GalleryCarousel_heading {
  font-size: 32px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
  &::after {
    content: '';
    display: block;
    position: relative;
    margin: 20px auto;
    width: 75px;
    height: 2px;
    background-color: ${colors.brand2};
  }
}
.GalleryCarousel_description {
  margin: 0 0 15px 0;
}
.GalleryCarousel_description p {
  font-size: 23px;
  text-align: center;
}
.GalleryCarousel_wrapper {
    position: relative;
    padding: 60px 0;
    margin: 0 0 60px 0;
    background-color: ${colors.brand6};
    background-image: url('/images/pattern-01-dark.svg');
    background-size: 110% auto;
    background-position: center center;
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      background-color: ${colors.brand6};
      background-image: url('/images/pattern-01-dark.svg');
      background-size: 110% auto;
      background-position: center center;
    }
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 400px;
      background-image: linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0.00) 99%);
      background-size: cover;
      z-index: 0;
    }
    @media (min-width: 992px) {
      padding: 90px 0;
    }
  }
.ScrollTarget {
  position: absolute;
  display: block;
  top: -200px;
}
`;

function PhotoGallery({ content }) {
  return (
    <div className={styles}>
      <Sticky style={{ zIndex: 100, top: 70 }}>
        <ul className="PhotoGallery_menu">
          {
            content.map(gallery => {
              return (
                <li className="PhotoGallery_menuItem" key={get(gallery, '_id')}>
                  <SmoothLink href={`#${Slugify(get(gallery, 'category_name'))}`}>{get(gallery, 'category_name')}</SmoothLink>
                </li>
              );
            })
          }
        </ul>
      </Sticky>
      {
        content.map(gallery => {
          return (
            <div className="GalleryCarousel_wrapper" key={get(gallery, '_id')}>
              <div className="ScrollTarget" id={Slugify(get(gallery, 'category_name'))} />
              <div className="container">
                <div className="row">
                  <div className="col-lg-8 mx-lg-auto">
                    <h3 className="GalleryCarousel_heading">{get(gallery, 'category_name')}</h3>
                    <div className="GalleryCarousel_description" dangerouslySetInnerHTML={SanitizeHtml(get(gallery, 'category_description', ''))} />
                  </div>
                </div>
              </div>
              <Carousel
                key={get(gallery, '_id')}
                items={get(gallery, 'category_photos', [])}
                thumbnails
                mainImageProps={{
                  width: 2000,
                  height: 1125,
                }}
                thumbnailImageProps={{
                  width: 1066,
                  height: 600,
                }}
              />
            </div>
          );
        })
      }
    </div>
  );
}

PhotoGallery.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  router: true,
})(PhotoGallery);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PhotoGallery.section.js